import React from 'react'
import { Switch } from 'react-router-dom'
import { Route } from 'react-router'
import Layout from '../containers/Layout'
import Home from '../containers/Home/Home'
import Success from '../containers/Home/Success'
import Cancel from '../containers/Home/Cancel'
import Privacy from '../containers/Home/Privacy'
import Terms from '../containers/Home/Terms'
// import Random from '../containers/Home/Random'

const Routes = (props) => (

  <Switch location={props.location}>
    <Route exact path='/' render={(props) => <Layout location={props.location}><Home /></Layout>} />
    <Route exact path='/success' render={(props) => <Layout location={props.location}><Success /></Layout>} />
    <Route exact path='/cancel' render={(props) => <Layout location={props.location}><Cancel /></Layout>} />
    <Route exact path='/privacy' render={(props) => <Layout location={props.location}><Privacy /></Layout>} />
    <Route exact path='/terms' render={(props) => <Layout location={props.location}><Terms /></Layout>} />
    {/* <Route exact path='/pick-winner-1s2JasBSA01ASkDDaSDnna12Ok' render={(props) => <Random />} /> */}
  </Switch>

)

export default Routes
